import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import LoadingAbsolute from '../../LoadingAbsolute'
import Header from '../../Header'
import './index.css'
import ButtonComp from '../../ButtonComp'
import CheckboxGroup from '../../CheckboxGroup'
import ArrowDownSvg from '../../../assets/icons/ArrowDownSvg'
import MahalleModal from '../TUBITAKDergiForm/Modals/MahalleModal'
import IlceModal from '../TUBITAKDergiForm/Modals/IlceModal'
import { Button } from 'reactstrap'
import InputDisabled from '../../InputDisabled'
import InputComp from '../../InputComp'
import TubitakWarningModal from '../TUBITAKDergiForm/Modals/TubitakWarningModal'
import axios from 'axios'

const TesislerBasvuruForm = () => {
  const { state } = useLocation()
  const navigate = useNavigate()
  const [loading, setLoading] = useState(true)
  const [self, setSelf] = useState(false)
  const [kid, setKid] = useState(false)
  const [basvuruType, setBasvuruType] = useState(null)

  const [isIkametgah, setIsIkametgah] = useState(false)

  const [secondAdress, setSecondAdress] = useState('')

  const [labelAddress, setLabelAddress] = useState('')

  const [labelName, setLabelName] = useState(null)
  const [labelSurname, setLabelSurname] = useState(null)

  const [InputName, setInputName] = useState('')
  const [InputSurname, setInputSurname] = useState('')
  const [InputTC, setInputTC] = useState('')
  const [InputDate, setInputDate] = useState('')

  const [InputNameError, setInputNameError] = useState(false)
  const [InputSurnameError, setInputSurnameError] = useState(false)
  const [InputTCError, setInputTCError] = useState(false)
  const [InputDateError, setInputDateError] = useState(false)

  const [selectedAddress, setSelectedAdress] = useState(
    labelAddress === '' ? 'yeni' : 'ikametgah'
  )

  const [mahalleLabelClass, setMahalleLabelClass] = useState('selectLabel')
  const [adressLabelClass, setAdressLabelClass] = useState('selectLabel')
  const [mahalleInputClass, setMahalleInputClass] = useState('selectInput')
  const [adressInputClass, setAdressInputClass] = useState('selectTextArea')

  const [mahalleler, setMahalleler] = useState(null)
  const [ilceler, setIlceler] = useState(null)
  const [ilceId, setIlceId] = useState(684)
  const [selectedIlce, setSelectedIlce] = useState('KARATAY')
  const [selectedMahalle, setSelectedMahalle] = useState('Seçiniz...')
  const [selectedMahalleId, setSelectedMahalleId] = useState(null)
  const [ilceModalOpen, setIlceModalOpen] = useState(false)
  const [mahalleModalOpen, setMahalleModalOpen] = useState(false)

  const [tesislerData, setTesislerData] = useState([])

  const [warningModalOpen, setWarningModalOpen] = useState({
    state: '',
    active: false,
    message: '',
  })

  useEffect(() => {
    axios
      .get(
        `${process.env.REACT_APP_BASE_URL}/api/dijital_basvuru/sosyal-tesisleri-sorgula`,
        {
          params: {
            token: JSON.parse(localStorage.getItem('token')),
          },
        }
      )
      .then((res) => {
        setLoading(false)
        if (res.data.code === 200) {
          setIlceler(res.data.ilceler)
          setMahalleler(res.data.mahalleler)

          setLabelName(res.data.name)
          setLabelSurname(res.data.surname)
          setLabelAddress(res.data.address)
          setSelectedAdress(res.data.address ? 'ikametgah' : 'yeni')

          setTesislerData(res.data.tesisler)
        } else if (res.data.code === 400) {
          setWarningModalOpen({
            state: 'responseMessage',
            active: true,
            message: res.data.message,
          })
        }
      })
  }, [state])

  const handleNavigate = (type) => {
    console.log(type)
    console.log(ilceId)
    setBasvuruType(type)
    if (type === 'self') {
      setSelf(true)
      setKid(false)
      setSelectedAdress(labelAddress ? 'ikametgah' : 'yeni')
    } else if (type === 'kid') {
      setKid(true)
      setSelf(false)
      setSelectedAdress(labelAddress ? 'ikametgah' : 'yeni')
    }
  }

  const handleSave = () => {
    let route_data = {}
    let addressError = false
    if (selectedAddress === 'yeni') {
      if (selectedIlce === 'KARATAY' && !selectedMahalleId) {
        setMahalleInputClass('unSelectInput')
        setMahalleLabelClass('unSelectLabel')
        addressError = true
      } else {
        setMahalleInputClass('selectInput')
        setMahalleLabelClass('selectLabel')
      }

      if (secondAdress?.length >= 10) {
        setAdressInputClass('selectTextArea')
        setAdressLabelClass('selectLabel')
      } else {
        setAdressInputClass('unSelectInput')
        setAdressLabelClass('unSelectLabel')
        addressError = true
      }

      if (addressError) {
        return false
      }

      let kidError = false
      if (self) {
        if (
          secondAdress?.length >= 10 &&
          (selectedIlce === 'KARATAY' ? selectedMahalleId : true)
        ) {
          route_data = {
            id: state?.basvuru_id,
            name: labelName,
            surname: labelSurname,
            adress: secondAdress,
            ilce: selectedIlce,
            mahalle: selectedIlce === 'KARATAY' ? selectedMahalle : null,
            basvuru_sartlari_title: state?.basvuru_sartlari_title,
            tesisler_data: tesislerData,
            basvuru_sartlari_aciklama: state?.basvuru_sartlari_aciklama,
            selectedAddress: 'yeni',
            basvuru_type: basvuruType,
          }
        }
      } else {
        if (InputName?.length < 1) {
          setInputNameError(true)
          kidError = true
        } else {
          setInputNameError(false)
        }

        if (InputSurname?.length < 1) {
          setInputSurnameError(true)
          kidError = true
        } else {
          setInputSurnameError(false)
        }

        if (InputTC?.length < 11) {
          setInputTCError(true)
          kidError = true
        } else {
          setInputTCError(false)
        }

        if (InputDate?.length < 1) {
          setInputDateError(true)
          kidError = true
        } else {
          setInputDateError(false)
        }
        console.log('kidError:', kidError)
        if (kidError) {
          return false
        }

        if (
          secondAdress?.length >= 10 &&
          (selectedIlce === 'KARATAY' ? selectedMahalleId : true) &&
          InputName &&
          InputSurname &&
          InputTC &&
          InputDate
        ) {
          route_data = {
            id: state?.basvuru_id,
            name: InputName,
            surname: InputSurname,
            adress: secondAdress,
            ilce: selectedIlce,
            mahalle: selectedIlce === 'KARATAY' ? selectedMahalle : null,
            tc: InputTC,
            date: InputDate,
            tesisler_data: tesislerData,
            basvuru_sartlari_title: state?.basvuru_sartlari_title,
            basvuru_sartlari_aciklama: state?.basvuru_sartlari_aciklama,
            selectedAddress: 'yeni',
            basvuru_type: basvuruType,
          }
        }
      }
    } else {
      if (self) {
        route_data = {
          id: state?.basvuru_id,
          name: labelName,
          surname: labelSurname,
          adress: labelAddress,
          basvuru_sartlari_title: state?.basvuru_sartlari_title,
          tesisler_data: tesislerData,
          basvuru_sartlari_aciklama: state?.basvuru_sartlari_aciklama,
          selectedAddress: 'ikametgah',
          basvuru_type: basvuruType,
        }
      } else {
        let kidError = false
        if (InputName?.length < 1) {
          setInputNameError(true)
          kidError = true
        } else {
          setInputNameError(false)
        }

        if (InputSurname?.length < 1) {
          setInputSurnameError(true)
          kidError = true
        } else {
          setInputSurnameError(false)
        }

        if (InputTC?.length < 11) {
          setInputTCError(true)
          kidError = true
        } else {
          setInputTCError(false)
        }

        if (InputDate?.length < 1) {
          setInputDateError(true)
          kidError = true
        } else {
          setInputDateError(false)
        }

        if (kidError) {
          return false
        }

        if (InputName && InputSurname && InputTC && InputDate) {
          route_data = {
            id: state?.basvuru_id,
            name: InputName,
            surname: InputSurname,
            adress: labelAddress,
            tc: InputTC,
            date: InputDate,
            tesisler_data: tesislerData,
            basvuru_sartlari_title: state?.basvuru_sartlari_title,
            basvuru_sartlari_aciklama: state?.basvuru_sartlari_aciklama,
            selectedAddress: 'ikametgah',
            basvuru_type: basvuruType,
          }
        }
      }
    }
    navigate('/tesisler-list', {
      state: route_data,
    })
  }

  return (
    <>
      {loading ? <LoadingAbsolute text={'Yükleniyor'} /> : null}
      <div className='hide-scrollbar'>
        <div
          style={{
            backgroundColor: '#fff',
            position: 'sticky',
            top: 0,
          }}
        >
          <Header
            onClick={() => {
              if (!kid && !self) {
                navigate(-1)
              } else {
                setKid(false)
                setSelf(false)
                setIsIkametgah(false)
                setSelectedMahalle('Seçiniz...')
                setSelectedMahalleId(null)
                setInputSurnameError(false)
                setInputNameError(false)
                setInputDateError(false)
                setInputTCError(false)
                setSecondAdress('')
                setInputName('')
                setInputDate('')
                setInputTC('')
                setInputSurname('')
                setAdressInputClass('selectTextArea')
                setAdressLabelClass('selectLabel')
                setMahalleInputClass('selectInput')
                setMahalleLabelClass('selectLabel')
              }
            }}
          />
        </div>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <img
            src={
              'https://app.yanibasimdakaratay.com/uploads/dijital_basvurular/' +
              state?.basvuru_fotografi
            }
            alt=''
            width={'90%'}
            height={'100%'}
            style={{ borderRadius: '10px' }}
          />
        </div>

        <div className='divider' />
        {!self && !kid ? (
          <>
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                textAlign: 'center',
                marginTop: '1rem',
                marginBottom: '0.5rem',
                paddingLeft: '1rem',
                paddingRight: '1rem',
                paddingBottom: '0.5rem',
                fontSize: '0.9rem',
                color: '#535353',
              }}
            >
              Sosyal tesislerimizden faydalanmak için kendi adınıza veya
              çocuğunuzun adına başvuruda bulunabilirsiniz.
            </div>
            {
              console.log(state?.yas_siniri.split("-"))
            }
            <ButtonComp
              focus={self}
              onClick={() => {
                if (!(Number(state?.age) >= state?.yas_siniri.split("-")[0] && Number(state?.age) <= state?.yas_siniri.split("-")[1])) {
                  setWarningModalOpen({
                    active: true,
                    state: 'age',
                    message: 'Başvuru için yaşınız uygun değil.',
                  })
                } else {
                  handleNavigate('self')
                }
              }}
            >
              Kendi Adıma Başvuracağım
            </ButtonComp>
            <ButtonComp focus={kid} onClick={() => handleNavigate('kid')}>
              Çocuğum Adına Başvuracağım
            </ButtonComp>
          </>
        ) : (
          <>
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                flexWrap: 'wrap',
              }}
            >
              {labelName && labelSurname && self ? (
                <div className='userInfoDiv'>
                  <div className='form-input-div'>
                    <InputDisabled label={'Adınız'} value={labelName} />
                  </div>

                  <div className='form-input-div'>
                    <InputDisabled label={'Soyadınız'} value={labelSurname} />
                  </div>
                </div>
              ) : (
                <div className='userInfoDiv'>
                  <div className='form-input-div'>
                    <InputComp
                      label={'Öğrencinin Adı'}
                      value={InputName}
                      onChange={(e) => {
                        setInputName(e.target.value)
                        setInputNameError(false)
                      }}
                      placeholder={'Öğrencinin Adı...'}
                      error={InputNameError}
                    />
                  </div>

                  <div className='form-input-div'>
                    <InputComp
                      label={'Öğrencinin Soyadı'}
                      value={InputSurname}
                      onChange={(e) => {
                        setInputSurname(e.target.value)
                        setInputSurnameError(false)
                      }}
                      placeholder={'Öğrencinin Soyadı...'}
                      error={InputSurnameError}
                    />
                  </div>

                  <div className='form-input-div'>
                    <InputComp
                      type='number'
                      label={'Öğrenciye Ait T.C.'}
                      value={InputTC}
                      onChange={(e) => {
                        if (e.target.value?.length <= 11) {
                          setInputTC(e.target.value)
                        }
                        setInputTCError(false)
                      }}
                      placeholder={'Örn: 12345678912'}
                      error={InputTCError}
                    />
                  </div>

                  <div className='form-input-div'>
                    <InputComp
                      label={'Öğrencinin Doğum Tarihi'}
                      value={InputDate}
                      maxlength='10'
                      onChange={(e) => {
                        const regex = /^[0-9.]*$/

                        if (!regex.test(e.target.value)) {
                          setInputDate(e.target.value.replace(/[^0-9]/, ''))
                        } else {
                          setInputDate(
                            e.target.value.replace(
                              /^(\d{2})(\d{2})(\d{4})*/g,
                              '$1.$2.$3'
                            )
                          )
                        }

                        setInputDateError(false)
                      }}
                      placeholder={'gg.aa.yyyy'}
                      error={InputDateError}
                    />
                  </div>
                </div>
              )}
              {selectedAddress === 'ikametgah' && (
                <div
                  style={{
                    marginLeft: '1.3rem',
                    marginRight: '0.5rem',
                    width: '98%',
                  }}
                >
                  <InputDisabled
                    label={'İkamet Adresiniz'}
                    value={labelAddress}
                    textArea={true}
                  />
                </div>
              )}
            </div>
            {!isIkametgah && (
              <>
                {labelAddress && (
                  <CheckboxGroup
                    title={'İkamet Adresiniz'}
                    label1={'İkametgah Adresime Gönderilsin'}
                    label2={'Yeni Adres Girmek İstiyorum'}
                    value1={'ikametgah'}
                    value2={'yeni'}
                    selectedValue={selectedAddress}
                    setSelectedValue={setSelectedAdress}
                    labelAddress={labelAddress}
                    address={true}
                  />
                )}

                {selectedAddress === 'yeni' && (
                  <>
                    <div
                      style={{
                        padding: '1rem 1.5rem',
                      }}
                    >
                      <div
                        className='selectInputDiv'
                        style={{
                          display: 'flex',
                          flexDirection: 'row',
                          gap: '0.4rem',
                        }}
                      >
                        <div
                          style={{
                            width: '100%',
                          }}
                        >
                          <div className='selectLabel'>İlçe</div>
                          <div
                            className='selectInput'
                            onClick={() => {
                              setIlceModalOpen(true)
                            }}
                          >
                            <div>{selectedIlce}</div>{' '}
                            <ArrowDownSvg width={'1rem'} height={'1rem'} />
                          </div>
                        </div>

                        {selectedIlce === 'KARATAY' && (
                          <div
                            style={{
                              display: 'flex',
                              flexDirection: 'column',
                              width: '100%',
                            }}
                          >
                            <div>
                              <div className={mahalleLabelClass}>Mahalle</div>
                              <div
                                className={mahalleInputClass}
                                onClick={() => setMahalleModalOpen(true)}
                              >
                                <div>{selectedMahalle}</div>
                                <ArrowDownSvg
                                  width={'1rem'}
                                  height={'1rem'}
                                  stroke={
                                    mahalleInputClass === 'unSelectInput'
                                      ? 'red'
                                      : '#b5ccc2'
                                  }
                                />
                              </div>
                            </div>
                            {mahalleInputClass === 'unSelectInput' && (
                              <div
                                style={{
                                  marginTop: '0.1rem',
                                  marginLeft: '0.5rem',
                                  fontSize: '9px',
                                  color: 'red',
                                }}
                              >
                                Bu Alan Zorunludur.
                              </div>
                            )}
                          </div>
                        )}
                      </div>
                    </div>
                    <div
                      style={{
                        marginLeft: '1.5rem',
                        marginRight: '0.5rem',
                      }}
                    >
                      <div className={adressLabelClass}>Adresiniz</div>
                      <textarea
                        className={adressInputClass}
                        value={secondAdress}
                        onChange={(e) => {
                          if (e.target.value?.length >= 10) {
                            setAdressInputClass('selectTextArea')
                            setAdressLabelClass('selectLabel')
                          }
                          setSecondAdress(e.target.value)
                        }}
                        rows='3'
                        placeholder='Cadde, sokak, site/bina adı, daire numarasını eksiksiz olarak giriniz...'
                      ></textarea>
                      {adressInputClass === 'unSelectInput' && (
                        <div
                          style={{
                            marginTop: '0.1rem',
                            marginLeft: '0.5rem',
                            fontSize: '9px',
                            color: 'red',
                          }}
                        >
                          {secondAdress?.length === 0
                            ? 'Bu Alan Zorunludur.'
                            : 'En az 10 karakter olmalıdır.'}
                        </div>
                      )}
                    </div>
                  </>
                )}
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    marginTop: '1rem',
                    marginBottom: '2rem',
                  }}
                >
                  <Button
                    block
                    className='tubitakTamamla'
                    onClick={handleSave}
                    style={{
                      marginLeft: '1rem',
                      marginRight: '1rem',
                      backgroundColor: '#285843',
                      borderRadius: '20px',
                      padding: '0.6rem 0',
                    }}
                  >
                    Tesis Seçimine Devam Et
                  </Button>
                </div>
              </>
            )}
          </>
        )}

        {ilceler ? (
          <IlceModal
            show={ilceModalOpen}
            onHide={() => setIlceModalOpen(false)}
            setIlce={setSelectedIlce}
            setIlceId={setIlceId}
            setMahalleAdi={setSelectedMahalle}
            setMahalleid={setSelectedMahalleId}
            ilceler={ilceler}
          />
        ) : null}
        {mahalleler ? (
          <MahalleModal
            show={mahalleModalOpen}
            onHide={() => setMahalleModalOpen(false)}
            setMahalleAdi={setSelectedMahalle}
            setMahalleid={setSelectedMahalleId}
            mahalleler={mahalleler}
            setMahalleClass={() => {
              setMahalleInputClass('selectInput')
              setMahalleLabelClass('selectLabel')
            }}
          />
        ) : null}
        <TubitakWarningModal
          show={warningModalOpen.active}
          onHide={() => setWarningModalOpen({ state: '', active: false })}
          state={warningModalOpen.state}
          message={warningModalOpen.message}
        />
      </div>
    </>
  )
}

export default TesislerBasvuruForm
